import { SET_FEATUREDJOBS } from "../actions/types";

const featuredJobs = (state = null, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_FEATUREDJOBS:
      return payload;
    default:
      return state;
  }
};

export default featuredJobs;
